<template>
	<div>
		<div
			class="mob-bottom-nav"
			:class="{
			'header-hidden-mobile': resumeClinicOpen && !loginModalOpen,
			'header-over-modal': resumeClinicOpen && loginModalOpen,
			}"
		>

			<div
				class="nav-item"
				:class="{ active: notifOpen }"
				@click="toggleNotif"
			>
				<div class="nav-icon-container">
					<img
						v-if="notifOpen"
						src="@/assets/img/newMobNav/Bell_active.svg"
						alt="Notification"
					/>
					<img
						v-else
						src="@/assets/img/newMobNav/Bell_inActive.svg"
						alt="Notification"
					/>
					<img
						src="@/assets/img/newMobNav/Login_Dot_inActive.svg"
						class="notif-dot"
						alt=""
					/>
				</div>
				<span>Notification</span>
			</div>

			<div class="nav-separator"></div>

			<div
				class="nav-item"
				:class="{ active: loginModalOpen }"
				@click="triggerLoginModal(loginModalOpen)"
			>
				<img
					v-if="loginModalOpen"
					src="@/assets/img/newMobNav/Login_active.svg"
					alt="Log In"
				/>
				<img
					v-else
					src="@/assets/img/newMobNav/Login_Inactive.svg"
					alt="Log In"
				/>
				<span>Log In</span>
			</div>
		</div>
	</div>
</template>

<script>
import EventBus from "../../utils/EventBus";
import { config } from "@/config";
export default {
	data() {
		return {
			loginModalOpen: false,
			isMobileMenuOpen: false,
			resumeClinicOpen: false,
			notifOpen: false,
		};
	},
	mounted() {
		this.onSetNotifOpen = (val) => {
			this.notifOpen = val;
		};
		EventBus.$on("set-notif-open", this.onSetNotifOpen);
		this.onCloseLoginModal = () => {
			this.loginModalOpen = false;
		};
		this.onOpenLoginModal = () => {
			this.loginModalOpen = true;
		};
		this.onMobileMenuState = (open) => {
			this.isMobileMenuOpen = !!open;
		};
		this.onResumeClinicState = (state) => {
			this.resumeClinicOpen = state;
		};
		this.onResumeClinicClosed = (state) => {
			this.resumeClinicOpen = state;
		};
		EventBus.$on("resume-clinic-state", this.onResumeClinicState);
		EventBus.$on("resume-clinic-closed", this.onResumeClinicClosed);
		EventBus.$on("close-login-modal", this.onCloseLoginModal);
		EventBus.$on("open-login-modal", this.onOpenLoginModal);
		EventBus.$on("mobile-menu-state", this.onMobileMenuState);
	},

	beforeDestroy() {
		EventBus.$off("set-notif-open", this.onSetNotifOpen);
		EventBus.$off("resume-clinic-state", this.onResumeClinicState);
		EventBus.$off("resume-clinic-closed", this.onResumeClinicClosed);
		EventBus.$off("open-login-modal", this.onOpenLoginModal);
		EventBus.$off("close-login-modal", this.onCloseLoginModal);
		EventBus.$off("mobile-menu-state", this.onMobileMenuState);
	},
	watch: {},

	methods: {

		openLoginModal() {
			EventBus.$emit("open-login-modal");
		},

		toggleNotif() {
			const nextOpen = !this.notifOpen;
			if (nextOpen) {
				EventBus.$emit("close-resume-clinic");
			}
			if (nextOpen && this.loginModalOpen) {
				EventBus.$emit("close-login-modal");
			}

			if (nextOpen) {
				EventBus.$emit("close-header-search");
			}

			EventBus.$emit("set-notif-open", nextOpen);
		},
		triggerLoginModal(open) {
			if (open) {
				EventBus.$emit("close-login-modal");
				return;
			} else {
				EventBus.$emit("close-resume-clinic");
				EventBus.$emit("close-header-search");
				EventBus.$emit("close-mobile-menu");
				if (this.notifOpen) {
					EventBus.$emit("set-notif-open", false);
				}
				this.openLoginModal();
				this.loginModalOpen = true;
			}
		},
	},
};
</script>
<style scoped>
.mob-bottom-nav {
	display: flex;
	align-items: center;
	justify-content: space-around;
	position: fixed;
	bottom: 0;
	width: 100%;
	padding-bottom: env(safe-area-inset-bottom);
	height: calc(80px + env(safe-area-inset-bottom));
	background: #ffffff;
	border-top: 1px solid #efefef;
	z-index: 1041;
}
.mob-bottom-nav .nav-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;
	gap: 4px;
}

.mob-bottom-nav .nav-item span {
	font-family: "Inter", sans-serif;
	font-size: 13px;
	font-weight: 400;
	color: #7e808f;
}

.mob-bottom-nav .nav-item.active span {
	color: #20639b;
	font-weight: 700;
}

.mob-bottom-nav .nav-item img {
	height: 32px;
	width: auto;
}

.mob-bottom-nav .nav-icon-container {
	position: relative;
	display: flex;
}

.mob-bottom-nav .nav-icon-container .notif-dot {
	position: absolute;
	top: 1.35px;
	right: 0px;
	height: 6.78px !important;
	width: 6.78px !important;
	z-index: 2;
}

.mob-bottom-nav .nav-separator {
	width: 1px;
	height: 36px;
	background-color: #8C8C8C4D;
	align-self: center;
}

@media (min-width: 1028px) {
	.mob-bottom-nav {
		display: none;
	}
}
</style>
